import { THEME_COLOR } from 'constants/color';
import { useEffect } from 'react';

function usePWATemplateColor(color: string) {
  useEffect(() => {
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', color);

    return () => {
      document.querySelector('meta[name="theme-color"]')?.setAttribute('content', THEME_COLOR.BLUE);
    };
  }, [color]);
}

export default usePWATemplateColor;
